import { render } from "./CurrentUserFormFills.vue?vue&type=template&id=f14ffbc6"
import script from "./CurrentUserFormFills.vue?vue&type=script&lang=js"
export * from "./CurrentUserFormFills.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/poshakjojomama-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__